export const types = ["outline", "filled"];
export const allSizes = ["small", "regular", "large"];
export const smallLarge = ["small", "large"];
export const xSmallLarge = ["xSmall", "small", "large"];

// for backward compatibility purpose
export const sizeMapper = {
  [allSizes[0]]: 16,
  [allSizes[1]]: 24,
  [allSizes[2]]: 36
};
